/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {useEffect, useState} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {Crumb} from '@ion/core/src/types/entities';
import {GlobalGroupProps} from '@ion/core/src/types/general';
import {useDrawingComplete} from '../hooks/useDrawingComplete';
import CreateRectangularBoundaries from './CreateRectangularBoundaries';
import {GeofenceSearch} from './GeofenceSearch';
import SaveSettings from './SaveSettings';

type PolygonGeoFenceProps = GlobalGroupProps & {
  completeDrawing: Function;
  view: __esri.MapView;
  map: __esri.Map
  isVisible: boolean;
  assetCategories?: string[];
  geofenceSave?: Function;
  selectCrumbs?: Function;
  crumbs?: Crumb[];
  savingGeofence?: boolean;
  mapViewEl?: HTMLElement;
  geoFencesGraphicsLayerRef?: {
    current: null | __esri.Layer;
  };
  sketchViewModelRef?: {
    current: null | __esri.Layer;
  };
  selectedMapPointRef?: {
    current: null | __esri.Layer;
  };
  cancelDrawing?: Function;
  mapClickHandler?: any;
  setMapClickHandler?: (val: any) => void;
  handleBack?: Function;
  closeGeoFencePanel?: Function;
  handleApplyBoundary?: Function;
  isBoundary?: boolean;
  useHereApi?: boolean;
  isPhone?: boolean;
  isFMTracking?: boolean;
  toggleShowBoundaryPanel?: Function;
};

export function PolygonGeoFence({
  map,
  completeDrawing,
  view,
  isVisible,
  assetCategories,
  geofenceSave,
  selectCrumbs,
  crumbs,
  savingGeofence,
  mapViewEl,
  geoFencesGraphicsLayerRef,
  sketchViewModelRef,
  selectedMapPointRef,
  cancelDrawing,
  mapClickHandler,
  setMapClickHandler,
  handleBack,
  globalGroup,
  accountMap,
  closeGeoFencePanel,
  handleApplyBoundary,
  isBoundary,
  isPhone,
  toggleShowBoundaryPanel,
  useHereApi = false,
  isFMTracking = false
}: PolygonGeoFenceProps) {
  const [drawingComplete, setDrawingComplete]         = useState(false);
  const [finishedDrawing, onCompleteDrawing]          = useDrawingComplete(isBoundary, handleApplyBoundary);
  const [finalDrawingDetails, setFinalDrawingDetails] = useState(null);
  const [selectedMapPoint, setSelectedMapPoint]       = useState(selectedMapPointRef);

  useEffect(() => {
    if (finalDrawingDetails) completeDrawing(finalDrawingDetails);
  }, [finalDrawingDetails]);

  useEffect(() => {
    setSelectedMapPoint(selectedMapPointRef);
  }, [selectedMapPointRef?.current]);

  const handleSetSelectedMapPoint = function(value) {
    setSelectedMapPoint(value);
  };

  return (
    <>
      {finishedDrawing ? (
        <SaveSettings assetCategories={assetCategories}
          accountMap={accountMap}
          globalGroup={globalGroup}
          finalDrawingDetails={finalDrawingDetails}
          geofenceSave={geofenceSave}
          selectCrumbs={selectCrumbs}
          closeGeoFencePanel={closeGeoFencePanel}
          handleBack={handleBack}
          crumbs={crumbs}
          savingGeofence={savingGeofence}
          geoFencesGraphicsLayerRef={geoFencesGraphicsLayerRef}
          sketchViewModelRef={sketchViewModelRef}
          selectedMapPointRef={selectedMapPoint}
          map={map}
          mapClickHandler={mapClickHandler} />
      ): (
        <GeofenceSearch view={view}
          map={map}
          useHereApi={useHereApi}
          geofenceType={translate('maps:geofences.polygon')}
          isVisible={isVisible}
          drawingComplete={drawingComplete}
          handleBack={handleBack}
          crumbs={crumbs}
          selectCrumbs={selectCrumbs}
          toggleShowBoundaryPanel={toggleShowBoundaryPanel}
          handleCompleteDrawing={onCompleteDrawing}
          handleSetSelectedMapPoint={handleSetSelectedMapPoint}
          mapClickHandler={mapClickHandler}
          isPhone={isPhone} />
      )}
      <CreateRectangularBoundaries map={map}
        mapView={view}
        isFMTracking={isFMTracking}
        setDrawingComplete={setDrawingComplete}
        setFinalDrawingDetails={setFinalDrawingDetails}
        finishedDrawing={finishedDrawing}
        mapViewEl={mapViewEl}
        geoFencesGraphicsLayerRef={geoFencesGraphicsLayerRef}
        sketchViewModelRef={sketchViewModelRef}
        selectedMapPointRef={selectedMapPoint}
        cancelDrawing={cancelDrawing}
        mapClickHandler={mapClickHandler}
        setMapClickHandler={setMapClickHandler} />
    </>
  );
}
